import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import RootErrorBoundary from './components/RootErrorBoundary.jsx'
import './styles/index.css'

// Remove initial HTML loader when React mounts
const removeInitialLoader = () => {
  const loader = document.getElementById('initial-loader')
  if (loader) {
    loader.style.opacity = '0'
    loader.style.transition = 'opacity 0.3s'
    setTimeout(() => loader.remove(), 300)
  }
}

const rootEl = document.getElementById('root')
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
)

// Remove loader after React has mounted
setTimeout(removeInitialLoader, 50)

// Global runtime guards to prevent blank white screen
window.addEventListener('error', (e) => {
  console.error('[window.error]', e?.error || e?.message)
})
window.addEventListener('unhandledrejection', (e) => {
  console.error('[unhandledrejection]', e?.reason)
})
